var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x90\x9C\xE7\xB4\xA2",
    opacity: 0.596052
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    opacity: 0.01,
    width: 16,
    height: 16,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6792 7.33962C13.6792 3.83835 10.8409 1 7.33962 1C3.83835 1 1 3.83835 1 7.33962C1 10.8409 3.83835 13.6792 7.33962 13.6792C8.79593 13.6792 10.1376 13.1882 11.2079 12.3627L13.6511 14.7718L13.7405 14.8479C14.0523 15.0759 14.4924 15.0473 14.7718 14.764C15.0791 14.4524 15.0756 13.9506 14.764 13.6433L12.3332 11.2459C13.1765 10.1693 13.6792 8.81319 13.6792 7.33962ZM2.58491 7.33962C2.58491 4.71366 4.71366 2.58491 7.33962 2.58491C9.96558 2.58491 12.0943 4.71366 12.0943 7.33962C12.0943 9.96558 9.96558 12.0943 7.33962 12.0943C4.71366 12.0943 2.58491 9.96558 2.58491 7.33962Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/搜索.537a14153b141024b39fae4e77599f3e.svg";
export { ForwardRef as ReactComponent };